import { TextContainer } from "@/types";

// The full text lives in `file`; `text` is only its truncated preview.
export const isTextPreviewContainer = (
  value: unknown
): value is TextContainer =>
  typeof value === "object" &&
  value !== null &&
  "has_preview" in value &&
  (value as TextContainer).has_preview === true &&
  "file" in value &&
  (value as TextContainer).file != null;
